import React, { useEffect, useState } from "react";
import useApi from "../../hooks/useApi";
import checkIfUserHasAccess from "../common/UserCheckAccess";

const ProductsModalBottomTables = ({ selectedProduct, BASE_URL }) => {
  const [alternatives, setAlternatives] = useState([]);
  const [itemStatsData, setItemStatsData] = useState([]);
  const COMPANY_CODE = localStorage.getItem("companyCode") || "-";
  // const API_PATHS =
  //   JSON.parse(localStorage.getItem("apiPaths")) ||
  //   "https://cubixweberp.com:213";
  const API_BASE_URL = `${BASE_URL}/api/CRMStockList/${COMPANY_CODE}`;

  const { request } = useApi();

  const getSafeProductId = (product) =>
    product?.Code?.toString()?.replace(/\//g, "%2F") || "";

  const fetchData = async (endpoint, setter) => {
    try {
      const safeProductId = getSafeProductId(selectedProduct);
      const url = `${API_BASE_URL}/${endpoint}/${safeProductId}/-/-`;
      const response = await request({
        url,
        method: "GET",
        timeout: 5000,
      });
      setter(response || []);
    } catch (err) {
      setter([]);
    }
  };
  useEffect(() => {
    if (!selectedProduct) {
      setAlternatives([]);
      setItemStatsData([]);
      return;
    }

    fetchData("ITEMSTATISTICS", (data) => setItemStatsData(data[0] || {}));
    fetchData("GETSUBSTITUTES", setAlternatives);
  }, [selectedProduct]);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 items-start">
      <div className="flex-1 flex rounded-xl shadow-lg overflow-hidden border border-gray-300 min-h-[250px] max-h-[250px]  overflow-y-auto ">
        <div className="bg-gradient-to-b from-green-500 to-green-600 flex items-center justify-center w-[60px]">
          <div className="transform -rotate-90 whitespace-nowrap text-white font-semibold origin-center">
            Alternatives
          </div>
        </div>

        <div className="w-full relative">
          <div className="grid grid-cols-4 bg-white border-b text-gray-700 text-xs font-semibold px-4 py-2 w-full sticky top-0">
            <div>Code</div>
            <div>Substitute</div>
            <div className="text-center">Qty</div>
            <div className="text-right">Price</div>
          </div>

          <div className="divide-y divide-gray-200">
            {alternatives?.map((alt, index) => (
              <div
                key={alt.Substitutes + index}
                className="grid grid-cols-4 items-center px-4 py-2 text-sm"
              >
                <div className="truncate font-medium text-blue-700">
                  {alt.code}
                </div>
                <div className="truncate text-gray-600 text-xs">
                  {alt.Substitutes}
                </div>
                <div
                  className={`rounded font-semibold text-center inline-block ${
                    alt.Qty >= 0 ? "text-green-700" : "text-red-700"
                  }`}
                >
                  {alt.Qty}
                </div>
                <div className="font-bold text-green-700 text-right">
                  {alt.Price?.toFixed(2)}
                </div>
              </div>
            ))}

            {alternatives?.length === 0 && (
              <div className="text-center text-gray-500 text-xs py-4">
                No alternatives available.
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="flex-1 flex rounded-xl shadow-lg overflow-hidden border border-gray-300 min-h-[250px] max-h-[250px]  overflow-y-auto ">
        <div className="bg-gradient-to-b from-blue-600 to-blue-700 flex items-center justify-center w-[60px]">
          <div className="transform -rotate-90 whitespace-nowrap text-white font-semibold origin-center">
            Item Statistics
          </div>
        </div>

        <div className="p-3 overflow-x-auto w-full">
          {Object.keys(itemStatsData)?.length === 0 ? (
            <div className="text-center text-gray-500 text-xs py-4">
              No statistics available.
            </div>
          ) : (
            <div className="flex flex-wrap gap-3 min-w-fit">
              {Object.entries(itemStatsData)
                ?.filter(([key]) => !["code", "idesc"]?.includes(key))
                ?.filter(([key]) =>
                  key === "LastSalesPrice" ? checkIfUserHasAccess("NR") : true,
                )
                ?.map(([key, value]) => (
                  <div
                    key={key}
                    className="bg-gray-50 rounded-lg px-2 py-2 flex-shrink-0 hover:bg-gray-100 transition-colors border border-gray-200 min-w-[140px] "
                  >
                    <div className="text-xs font-medium text-gray-600 mb-1">
                      {key}
                    </div>
                    <div className="text-sm font-semibold text-gray-900">
                      {value === null ? "—" : value.toString()}
                    </div>
                  </div>
                ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductsModalBottomTables;
